import McoLogo from "../../images/mco-logo.svg?react"
import CenteredContainer from "./CenteredContainer"

export const loadingIndicatorClass = "mco-loading-indicator"

export function Loading({
	contentFor,
	failure
}: {
	contentFor?: string
	failure?: boolean
}) {
	return (
		<div
			className={`align-middle ${loadingIndicatorClass}`}
			style={{
				textAlign: "center",
				fontFamily: "'Lucida Sans Unicode', 'Lucida Grande', sans-serif"
			}}
			data-loading-content-for={contentFor}
			data-loading-failure={failure}
		>
			<McoLogo
				style={{
					animation: failure ? undefined : "pulse linear 2s infinite",
					height: "100px",
					width: "100px",
					margin: "auto"
				}}
			/>
			<br />
			Loading, please wait
		</div>
	)
}

const LoadingMessage = ({ children }: { children?: React.ReactNode }) => (
	<CenteredContainer className={loadingIndicatorClass}>
		<McoLogo
			style={{
				height: "20vmin",
				pointerEvents: "none",
				animation: "pulse linear 2s infinite"
			}}
		/>
		<h1 className="h4">{children || "Loading, please wait..."}</h1>
	</CenteredContainer>
)

export default LoadingMessage
